import NextLink from 'next/link'
import styled, { css } from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, radii, space, borderWidths, transitions } = theme

const neon = colors['cashme-blue-neon']

export const Help = styled.section`
  width: 100%;
  overflow: hidden;
  background-color: #00203C;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  padding: ${space['spacing-xl']} 8.5rem ${space['spacing-xxl']};

  @media (${media.phone}) {
    padding: ${space['spacing-xl']} ${space['spacing-md']} ${space['spacing-xxl']};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};
  margin-bottom: ${space['spacing-sm']};
`

export const Accordion = styled.div`
  display: flex;
  flex-direction: column;

  .ds-accordion-item {
    border-bottom: ${borderWidths['border-stroke-micro']} solid #fff3;
  }
`

export const Answer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  padding-top: ${space['spacing-md']};
  padding-bottom: ${space['spacing-lg']};
`

const inlineLink = css`
  color: ${neon};
  font: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  transition: ${transitions.default};

  &:hover {
    opacity: 0.8;
  }
`

export const InlineLink = styled(NextLink)`
  ${inlineLink}
`

export const InlineButton = styled.button`
  ${inlineLink}
  display: inline;
  padding: 0;
  background: none;
  border: none;
`

export const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xs']};
  margin-top: ${space['spacing-xs']};
`

export const ProductItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${space['spacing-md']};

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0.1875rem;
    width: 1px;
    height: calc(100% + ${space['spacing-xs']});
    transform: translateX(-50%);
    background-color: #fff3;
  }

  &:last-child::before {
    display: none;
  }
`

export const ProductBar = styled.span`
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  width: 0.5rem;
  height: 1.5rem;
  background-color: var(--colors-cyan-text-contrast);
  border-radius: 10px;
`

export const ProductLink = styled(NextLink)`
  display: flex;
  align-items: center;
  gap: ${space['spacing-sm']};
  flex: 1;
  min-width: 0;
  height: 4rem;
  padding: ${space['spacing-sm']} ${space['spacing-md']};
  color: var(--colors-neutral-text-contrast-default);
  background-color: ${colors['cashme-dark-blue']};
  border: ${borderWidths['border-stroke-micro']} solid ${neon}50;
  border-radius: ${radii['corner-radius-sm']};
  transition: ${transitions.default};

  svg {
    flex-shrink: 0;
  }

  &:hover {
    border-color: ${neon}90;
  }
`

export const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};
`

export const ContactLink = styled.a`
  ${inlineLink}
`
